import "es6-shim";
import "./ConfirmationPopup.css";
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { ReactNode } from "react";

interface IPopupProps {
    title: string,
    show: boolean,
    confirmButtonText?: string,
    cancelButtonText?: string
    disableConfirmButton?: boolean,
    children?: ReactNode,
    cancel(): void,
    confirm(): void
}
export const ConfirmationPopup = (props: IPopupProps) => {
    function onConfirm() {
        props.confirm();
    }
    function onCancel() {
        props.cancel();
    }

    if (!props.show) {
        return null;
    }
    return (
        <Modal
            onHide={props.cancel}
            show={props.show}
            dialogClassName={"customModal-with-700"}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title className="confirmation-title" >{props.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row">
                    {props.children}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="col-sm-12 text-center">
                    <button
                        id="cancel"
                        className="buttons-white"
                        style={{ float: "left" }}
                        onClick={onCancel}
                    >
                        {
                            props.cancelButtonText ? props.cancelButtonText : "Cancel"
                        }
                    </button>
                    <button
                        id="confirm"
                        className="buttons-blue"
                        style={{ float: "right" }}
                        onClick={onConfirm}
                        disabled={props.disableConfirmButton}
                    >
                        {
                            props.confirmButtonText ? props.confirmButtonText : "Confirm"
                        }
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/ConfirmationPopup/ConfirmationPopup.tsx